import { render, staticRenderFns } from "./Menu.vue?vue&type=template&id=8e791638&scoped=true&"
import script from "./Menu.vue?vue&type=script&lang=js&"
export * from "./Menu.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./Menu.vue?vue&type=style&index=0&id=8e791638&scoped=true&lang=css&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "8e791638",
  null
  ,true
)

export default component.exports